/** City-specific formal intake destinations for every "Talk to a human" link. */
const INTAKE_URLS: Record<string, string> = {
  Austin: 'https://tacostreetlocatingcom.involve.me/austinblogform',
  Dallas: 'https://tacostreetlocatingcom.involve.me/dallasquizblogform',
  Houston: 'https://tacostreetlocatingcom.involve.me/houstonblog',
};

export function getIntakeUrl(metro: string | null | undefined): string {
  return (metro && Object.prototype.hasOwnProperty.call(INTAKE_URLS, metro)
    ? INTAKE_URLS[metro]
    : INTAKE_URLS.Austin);
}
